import React from "react";
import Commons from "oc-commons/Commons";

export default class SidebarFrame extends React.Component {
    getSidebarParent() {
        return null;
    }

    render() {
        return (
            <aside id="scroll-sidebar" className="sidebar">
                <div className={"inner-sidebar"}>
                    <div className="sidebar-header row">
                        <div className="left col-1"></div>
                        <div className="middle col-12">
                            <div className="sidebar-title">{this.renderTitle()}</div>
                        </div>
                    </div>
                    <div className="sidebar-body">{this.renderBody()}</div>
                </div>
                <div className={"sticky-bottom " + (Commons.isEmpty(this.getSidebarParent()) ? "only-mobile " : "")}>
                    <button className="primary finished-button" onClick={() => APP.uiHandler.sidebar(this.getSidebarParent())} href="#">
                        {I18N("Fertig")}
                    </button>
                </div>
            </aside>
        );
    }
}
